export default {
	tag: 'Junior Cert | Leaving Cert | A-Level',
	universities: 'Top 10',
	grade_tit: 'Junior Cert | Leaving Cert | A-Level, all levels and all subjects!',
	price: '€12.9',
	'ft.price': '€36',
	location: 'Dublin',
	country_name: 'Ireland',
};
